import { FC } from 'react'
import { Label } from '@lifedot/atoms/Label'
import { css } from '@emotion/react'

const styles = {
  label: css({
    '> span': {
      margin: '0 4px 4px 0'
    }
  })
}

export interface LabelsProps {
  labels: Array<{ name: string }>
}

export const Labels: FC<LabelsProps> = ({ labels }) => {
  return (
    <div css={styles.label}>
      {labels.map((v, index) => (
        <Label key={index} color="gray6">
          {v.name}
        </Label>
      ))}
    </div>
  )
}
